import axios from 'axios';
import { useEffect, useRef } from 'react';

const useNetworkStatusHook= (setStatus, intervalTimer = 3000, intervalTimeout = 2000 ) => {
  const cancelTokenRef = useRef()
  useEffect(() => {
    const interval = setInterval(() => {
      cancelTokenRef.current = axios.CancelToken.source()

      axios.get('/blank.png', {
        mode: 'no-cors',
        headers: { 'Cache-Control': 'no-cache' },
        cancelToken: cancelTokenRef?.current?.token ?? ''
      })
        .then(() => setStatus(false))
        .catch(() => setStatus(true));

    setTimeout(() => {
      if (cancelTokenRef.current) cancelTokenRef.current.cancel()
    }, intervalTimeout)
    }, intervalTimer);

    return () => clearInterval(interval);
  }, []);
};

export default useNetworkStatusHook;
